export default {
    computed: {
        isUserConnected() {
            return this.$page.props.auth.user && !this.$page.props.is_guest
        },
    },
}
